import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-ambition',
  templateUrl: 'ambition.component.html',
  styleUrls: ['ambition.component.css'],
})
export class AmbitionComponent {
  @ViewChild('AmbitionSection') AmbitionSection!: ElementRef;

  ngAfterViewInit(): void {
    this.initIntersectionObserver();
  }

  private initIntersectionObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          //this.initCounters();

          observer.unobserve(this.AmbitionSection.nativeElement);
        }
      },
      {
        threshold: 0.1, // Adjust the threshold as needed
      }
    );

    observer.observe(this.AmbitionSection.nativeElement);
  }

  /* private initCounters() {
    this.animateCounter('employes', 30, false); // Pass false to avoid $ sign
    this.animateCounter('chiffre-affaires', 1500000, true);
    this.animateCounter('experts', 5, false);
  }

  private animateCounter(id: string, target: number, withDollar: boolean) {
    const element = document.getElementById(id);
    if (element) {
      let count = 0;
      const interval = setInterval(() => {
        count += Math.ceil(target / 100); // Increment by a portion of the target
        if (count >= target) {
          count = target;
          clearInterval(interval);
        }
        element.textContent = this.formatNumber(count, withDollar);
      }, 60); // Adjust the interval time for smoother or faster animation
    }
  }

  private formatNumber(value: number, withDollar: boolean): string {
    let formattedValue: string;
    if (value >= 1000000) {
      // Format number in millions
      formattedValue = (value / 1000000).toFixed(1) + 'M';
    } else if (value >= 1000) {
      // Format number in thousands
      formattedValue = (value / 1000).toFixed(1) + 'K';
    } else {
      formattedValue = value.toString();
    }
    return withDollar ? formattedValue + '$' : formattedValue;
  } */
}
